
  import imgixRuntime$qYtgoPI5uZBTu0vjJCr_j4IoC5JCbS9BfnJY6EVEqvc from '/var/lib/jenkins/workspace/Website Frontend - Production/node_modules/@nuxt/image/dist/runtime/providers/imgix'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "imgix",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "avif",
    "svg",
    "webp"
  ]
},
    /** @type {"imgix"} */
    provider: "imgix",
    providers: {
        ['imgix']: { setup: imgixRuntime$qYtgoPI5uZBTu0vjJCr_j4IoC5JCbS9BfnJY6EVEqvc, defaults: {"baseURL":"https://summitproedu.imgix.net"} }
    }
  }
